var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-form",
        {
          ref: "editPram",
          attrs: {
            rules: _vm.rules,
            model: _vm.editPram,
            "label-width": "110px",
          },
        },
        [
          _c("el-form-item", { attrs: { label: "关联用户：", prop: "uid" } }, [
            _c(
              "div",
              {
                staticClass: "upLoadPicBox",
                on: {
                  click: function ($event) {
                    _vm.userVisible = true
                  },
                },
              },
              [
                _vm.editPram.userAvatar
                  ? _c("div", { staticClass: "pictrue" }, [
                      _c("img", { attrs: { src: _vm.editPram.userAvatar } }),
                    ])
                  : _c("div", { staticClass: "upLoad" }, [
                      _c("i", { staticClass: "el-icon-camera cameraIconfont" }),
                    ]),
                _c("div", { staticClass: "nick" }, [
                  _vm._v(_vm._s(_vm.editPram.nickname)),
                ]),
                _c("div", { staticClass: "from-tips" }, [
                  _vm._v("员工必须在商城关注店铺"),
                ]),
              ]
            ),
          ]),
          _c(
            "el-form-item",
            { attrs: { label: "员工头像：", prop: "avatar" } },
            [
              _c(
                "div",
                {
                  staticClass: "upLoadPicBox",
                  on: {
                    click: function ($event) {
                      return _vm.modalPicTap("1")
                    },
                  },
                },
                [
                  _vm.editPram.avatar
                    ? _c("div", { staticClass: "pictrue" }, [
                        _c("img", { attrs: { src: _vm.editPram.avatar } }),
                      ])
                    : _c("div", { staticClass: "upLoad" }, [
                        _c("i", {
                          staticClass: "el-icon-camera cameraIconfont",
                        }),
                      ]),
                  _c("div", { staticClass: "from-tips" }, [
                    _vm._v(
                      "用于移动端商家管理工作台展示，建议：80*80PX，大小不超过5KB。"
                    ),
                  ]),
                ]
              ),
            ]
          ),
          _c(
            "el-form-item",
            { attrs: { label: "员工姓名：", prop: "name" } },
            [
              _c("el-input", {
                attrs: { placeholder: "请输入员工姓名" },
                model: {
                  value: _vm.editPram.name,
                  callback: function ($$v) {
                    _vm.$set(_vm.editPram, "name", $$v)
                  },
                  expression: "editPram.name",
                },
              }),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "手机号：", prop: "phone" } },
            [
              _c("el-input", {
                attrs: { placeholder: "请输入手机号" },
                model: {
                  value: _vm.editPram.phone,
                  callback: function ($$v) {
                    _vm.$set(_vm.editPram, "phone", $$v)
                  },
                  expression: "editPram.phone",
                },
              }),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "管理权限：", prop: "role" } },
            [
              _c(
                "el-checkbox-group",
                {
                  model: {
                    value: _vm.editPram.role,
                    callback: function ($$v) {
                      _vm.$set(_vm.editPram, "role", $$v)
                    },
                    expression: "editPram.role",
                  },
                },
                [
                  _c("el-checkbox", { attrs: { label: "1" } }, [
                    _vm._v("订单管理"),
                  ]),
                  _c("el-checkbox", { attrs: { label: "2" } }, [
                    _vm._v("商品管理"),
                  ]),
                  _c("el-checkbox", { attrs: { label: "3" } }, [
                    _vm._v("售后管理"),
                  ]),
                  _c("el-checkbox", { attrs: { label: "5" } }, [
                    _vm._v("订单核销"),
                  ]),
                  _c("el-checkbox", { attrs: { label: "6" } }, [
                    _vm._v("销量/用户统计"),
                  ]),
                ],
                1
              ),
              _c("div", { staticClass: "from-tips" }, [
                _vm._v("管理权限控制该员工能够进行的操作限制。"),
              ]),
            ],
            1
          ),
          _vm.hasVerificationRole
            ? _c(
                "el-form-item",
                { attrs: { label: "核销商品范围：" } },
                [
                  _c(
                    "el-radio-group",
                    {
                      model: {
                        value: _vm.editPram.verificationScopeType,
                        callback: function ($$v) {
                          _vm.$set(_vm.editPram, "verificationScopeType", $$v)
                        },
                        expression: "editPram.verificationScopeType",
                      },
                    },
                    [
                      _c("el-radio", { attrs: { label: 1 } }, [
                        _vm._v("全部商品"),
                      ]),
                      _c("el-radio", { attrs: { label: 2 } }, [
                        _vm._v("指定商品"),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm.hasVerificationRole && _vm.editPram.verificationScopeType === 2
            ? _c(
                "el-form-item",
                { attrs: { label: "可核销商品：" } },
                [
                  _c(
                    "div",
                    { staticClass: "scope-toolbar" },
                    [
                      _c(
                        "el-button",
                        {
                          attrs: { size: "small", type: "primary" },
                          on: { click: _vm.openProductDialog },
                        },
                        [_vm._v("选择商品")]
                      ),
                      _c("span", { staticClass: "scope-count" }, [
                        _vm._v(
                          "已选 " +
                            _vm._s(_vm.editPram.selectedProducts.length) +
                            " 个商品"
                        ),
                      ]),
                    ],
                    1
                  ),
                  _vm.editPram.selectedProducts.length
                    ? _c(
                        "el-table",
                        {
                          staticClass: "selected-product-table",
                          attrs: {
                            data: _vm.editPram.selectedProducts,
                            size: "mini",
                            border: "",
                          },
                        },
                        [
                          _c("el-table-column", {
                            attrs: { label: "商品", "min-width": "260" },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function (ref) {
                                    var row = ref.row
                                    return [
                                      _c(
                                        "div",
                                        { staticClass: "product-cell" },
                                        [
                                          row.image
                                            ? _c("img", {
                                                staticClass: "product-image",
                                                attrs: { src: row.image },
                                              })
                                            : _vm._e(),
                                          _c("span", [
                                            _vm._v(_vm._s(row.name)),
                                          ]),
                                        ]
                                      ),
                                    ]
                                  },
                                },
                              ],
                              null,
                              false,
                              4104013675
                            ),
                          }),
                          _c("el-table-column", {
                            attrs: {
                              prop: "productId",
                              label: "商品ID",
                              "min-width": "90",
                            },
                          }),
                          _c("el-table-column", {
                            attrs: {
                              prop: "stock",
                              label: "库存",
                              "min-width": "70",
                            },
                          }),
                          _c("el-table-column", {
                            attrs: { label: "操作", "min-width": "70" },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function (ref) {
                                    var row = ref.row
                                    return [
                                      _c(
                                        "el-button",
                                        {
                                          attrs: { type: "text" },
                                          on: {
                                            click: function ($event) {
                                              return _vm.removeSelectedProduct(
                                                row.productId
                                              )
                                            },
                                          },
                                        },
                                        [_vm._v("移除")]
                                      ),
                                    ]
                                  },
                                },
                              ],
                              null,
                              false,
                              4111780288
                            ),
                          }),
                        ],
                        1
                      )
                    : _c("div", { staticClass: "empty-products" }, [
                        _vm._v("请选择可核销商品"),
                      ]),
                ],
                1
              )
            : _vm._e(),
          _c(
            "el-form-item",
            { attrs: { label: "状态：", prop: "status" } },
            [
              _c("el-switch", {
                attrs: { "active-value": 1, "inactive-value": 0 },
                model: {
                  value: _vm.editPram.status,
                  callback: function ($$v) {
                    _vm.$set(_vm.editPram, "status", $$v)
                  },
                  expression: "editPram.status",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        {
          staticClass: "dialog-footer-inner",
          attrs: { slot: "footer" },
          slot: "footer",
        },
        [
          _c(
            "el-button",
            {
              on: {
                click: function ($event) {
                  return _vm.handlerClose()
                },
              },
            },
            [_vm._v("取消")]
          ),
          _c(
            "el-button",
            {
              attrs: { type: "primary" },
              on: {
                click: function ($event) {
                  return _vm.handlerSubmit("editPram")
                },
              },
            },
            [_vm._v("确定")]
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "关联用户列表",
            visible: _vm.userVisible,
            width: "900px",
            "append-to-body": true,
            "close-on-click-modal": false,
          },
          on: {
            "update:visible": function ($event) {
              _vm.userVisible = $event
            },
          },
        },
        [
          _vm.userVisible
            ? _c("userList", { on: { getRow: _vm.getRow } })
            : _vm._e(),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "选择可核销商品",
            visible: _vm.productVisible,
            width: "900px",
            "append-to-body": true,
            "close-on-click-modal": false,
          },
          on: {
            "update:visible": function ($event) {
              _vm.productVisible = $event
            },
          },
        },
        [
          _c(
            "div",
            { staticClass: "scope-toolbar mb12" },
            [
              _c("el-input", {
                staticClass: "product-search-input",
                attrs: {
                  placeholder: "请输入商品名称",
                  clearable: "",
                  size: "small",
                },
                nativeOn: {
                  keyup: function ($event) {
                    if (
                      !$event.type.indexOf("key") &&
                      _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                    ) {
                      return null
                    }
                    return _vm.getProductList($event)
                  },
                },
                model: {
                  value: _vm.productSearch.keywords,
                  callback: function ($$v) {
                    _vm.$set(_vm.productSearch, "keywords", $$v)
                  },
                  expression: "productSearch.keywords",
                },
              }),
              _c(
                "el-button",
                {
                  attrs: { size: "small", type: "primary" },
                  on: { click: _vm.getProductList },
                },
                [_vm._v("搜索")]
              ),
            ],
            1
          ),
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.productLoading,
                  expression: "productLoading",
                },
              ],
              ref: "productTable",
              attrs: {
                data: _vm.productTableData.list,
                size: "mini",
                border: "",
                "row-key": "id",
              },
              on: { "selection-change": _vm.handleProductSelectionChange },
            },
            [
              _c("el-table-column", {
                attrs: {
                  type: "selection",
                  width: "55",
                  "reserve-selection": "",
                },
              }),
              _c("el-table-column", {
                attrs: { label: "商品", "min-width": "280" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (ref) {
                      var row = ref.row
                      return [
                        _c("div", { staticClass: "product-cell" }, [
                          row.image
                            ? _c("img", {
                                staticClass: "product-image",
                                attrs: { src: row.image },
                              })
                            : _vm._e(),
                          _c("span", [_vm._v(_vm._s(row.name))]),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { prop: "id", label: "商品ID", "min-width": "90" },
              }),
              _c("el-table-column", {
                attrs: { prop: "price", label: "售价", "min-width": "90" },
              }),
              _c("el-table-column", {
                attrs: { prop: "stock", label: "库存", "min-width": "80" },
              }),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "block" },
            [
              _c("el-pagination", {
                attrs: {
                  background: "",
                  layout: "total, sizes, prev, pager, next, jumper",
                  "current-page": _vm.productSearch.page,
                  "page-size": _vm.productSearch.limit,
                  total: _vm.productTableData.total,
                },
                on: {
                  "size-change": _vm.handleProductSizeChange,
                  "current-change": _vm.handleProductCurrentChange,
                },
              }),
            ],
            1
          ),
          _c(
            "div",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.productVisible = false
                    },
                  },
                },
                [_vm._v("取消")]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.confirmSelectedProducts },
                },
                [_vm._v("确定")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }